<template>
  <div>
    <p class="tanggal">Last Update: Feb 26, 2021</p>
    <p class="title-1">I. DEFINISI</p>
    <p class="Desc">
      “Anda” adalah calon Pemberi Pinjaman, calon Penerima Pinjaman, Penerima
      Pinjaman dna Pemberi Pinjaman.
    </p>
    <p class="Desc">
      “Layanan Dompet Kilat” adalah layanan pinjam meminjam uang berbasis
      teknologi informasi yang mempertemukan Pemberi Pinjaman dengan Penerima
      Pinjaman yang diselenggarakan oleh Dompet Kilat.
    </p>
    <p class="Desc">
      “Dompet Kilat” adalah bagian dari PT Indo Fin Tek, suatu perseroan
      terbatas yang didirikan berdasarkan hukum negara Republik Indonesia yang
      memiliki kegiatan usaha sebagai penyelenggara Layanan Pinjam Meminjam Uang
      Berbasis Teknologi Informasi dan telah memiliki izin operasional dari
      Otoritas Jasa Keuangan.
    </p>
    <p class="Desc">
      “Penerima Pinjaman” adalah orang dan/atau badan hukum yang mempunyai utang
      karena perjanjian pinjam meminjam.
    </p>
    <p class="Desc">
      “Pemberi Pinjaman” adalah orang dan/atau badan hukum yang mempunyai
      piutang karena perjanjian pinjam meminjam.
    </p>
    <p class="title-1">II. KETENTUAN UMUM</p>
    <p class="Desc">
      Layanan Dompet Kilat hanya dapat digunakan oleh setiap pengguna berusia
      minimal 21 tahun dan memiliki kapasitas hukum, hak, kuasa, dan otoritas
      yang diperlukan untuk terikat pada Syarat dan Ketentuan ini. Dompet Kilat
      dapat memberikan persetujuan kepada Anda yang berusia di bawah 21 tahun
      dengan pertimbangan Dompet Kilat.
    </p>
    <p class="Desc">
      Anda akan menggunakan Layanan Dompet Kilat hanya untuk tujuan yang sah dan
      tidak bertentangan dengan hukum yang berlaku.
    </p>
    <p class="title-1">III. AKUN</p>
    <p class="Desc">
      Pada proses pendaftaran/pembuatan akun, Anda wajib menyampaikan informasi
      dan dokumen yang benar, akurat, lengkap, terbaru dan tidak menyesatkan
      atau menipu. Anda diwajibkan untuk melakukan pembaharuan informasi dan
      data pribadi dalam hal terjadi perubahan informasi dan data tentang Anda.
      Kegagalan untuk menyampaikan informasi dan data yang benar dan lengkap
      merupakan pelanggaran terhadap Syarat dan Ketentuan ini yang dapat
      mengakibatkan penghentian atau pemblokiran akun Anda pada Layanan Dompet
      Kilat. Anda bertanggung jawab atas setiap kerugian yang timbul baik secara
      material maupun immaterial atas setiap ketidakbenaran data dan informasi
      yang Anda berikan.
    </p>
    <p class="Desc">
      Anda bertanggung jawab untuk menjaga kata sandi atau password yang Anda
      gunakan untuk mengakses Layanan Dompet Kilat. Anda setuju untuk tidak
      mengungkapkan kata sandi Anda kepada pihak ketiga. Anda harus segera
      memberitahu kami setelah menyadari terdapat pelanggaran keamanan atau
      penggunaan yang tidak sah dari akun Anda.
    </p>
    <p class="title-1">IV. LAYANAN DOMPET KILAT</p>
    <p class="Desc">
      Sehubungan dengan Layanan Dompet Kilat, Dompet Kilat memiliki peran
      sebatas penghubung antara Pemberi Pinjaman dan Penerima Pinjaman yang
      berperan sebagai penyedia, pengelola, dan pengatur transaksi pemberian
      fasilitas pinjaman antara Pemberi Pinjaman dan Penerima Pinjaman melalui
      Platform Dompet Kilat.
    </p>
    <p class="Desc">
      Transaksi pinjam meminjam antara Pemberi Pinjaman dan Penerima Pinjaman
      merupakan kesepakatan perdata antara Pemberi Pinjaman dengan Penerima
      Pinjaman, sehingga segala risiko yang timbul dari kesepakatan tersebut
      ditanggung sepenuhnya oleh masing-masing pihak. Risiko kredit atau gagal
      bayar ditanggung sepenuhnya oleh Pemberi Pinjaman.
    </p>
    <p class="Desc">
      Dompet Kilat berhak untuk melaksanakan prinsip mengenal nasabah (know your
      customer principle) dan uji kelayakan terhadap calon Pemberi Pinjaman dan
      calon Penerima Pinjaman. Dompet Kilat dapat menghubungi Anda, lembaga,
      perusahaan, atau individu terkait untuk mencari informasi, melakukan
      verifikasi dan konfirmasi informasi terkait Anda, termasuk namun tidak
      terbatas pada rekam jejak secara hukum dan keuangan Anda.
    </p>
    <p class="Desc">
      Dompet Kilat akan melaksanakan proses pengumpulan dana pinjaman
      (crowdfunding) selama paling lambat 30 (tiga puluh) hari kalender yang
      dapat diperjanjang oleh Dompet Kilat sesuai kebutuhan untuk mengumpulkan
      dana fasilitas pinjaman yang diajukan oleh Penerima Pinjaman. Apabila
      hasil proses crowdfunding tidak mencapai jumlah pinjaman yang diajukan
      oleh Penerima Pinjaman, Penerima Pinjaman setuju untuk meminjam sejumlah
      dana yang terkumpul dari proses crowfunding.
    </p>
    <p class="Desc">
      Dompet Kilat berhak memperoleh komisi sesuai kesepakatan antara Penerima
      Pinjaman dan Pemberi Pinjaman, serta biaya layanan yang termasuk namun
      tidak terbatas pada biaya asuransi sebesar 1% (satu persen) dari suku
      bunga yang mana biaya-biaya tersebut akan dibebankan kepada Penerima
      Pinjaman untuk setiap pinjaman.
    </p>
    <p class="title-1">V. HAL-HAL TERKAIT DATA PRIBADI</p>
    <p class="Desc">
      Anda menyetujui bahwa Dompet Kilat dapat mengumpulkan, menyimpan,
      memproses, mengakses, mengkaji, dan/atau menggunakan informasi dan data
      pribadi tentang Anda, baik yang didapatkan melalui Anda ataupun melalui
      sumber lain yang sesuai dengan hukum yang berlaku untuk tujuan penyediaan
      Layanan Dompet Kilat kepada Anda.
    </p>
    <p class="Desc">
      Anda menyetujui bahwa Dompet Kilat dapat membuka informasi tentang Anda
      kepada pihak ketiga yang bekerja sama dengan PT Indo Fin Tek yang
      diperlukan untuk tujuan verifikasi data, pemasaran dan penawaran,
      penganalisaan untuk kepentingan riset Dompet Kilat, pembubuhan tanda
      tangan elektronik, pembuatan dan pengelolaan virtual account dan rekening,
      pembubuhan e-materai, pengurusan asuransi dan aktivitas lain yang
      mendukung penyediaan Layanan Dompet Kilat sesuai dengan peraturan
      perundang-undangan yang berlaku.
    </p>
    <p class="Desc">
      Dompet Kilat memastikan bahwa seluruh data pribadi yang dikirimkan oleh
      Anda melalui Platform Dompet Kilat dilindungi dan dienkripsi dengan baik,
      termasuk namun tidak terbatas pada penggunaan teknologi SSL/TLS yang
      tersedia.
    </p>
    <p class="Desc">
      Dompet Kilat menyetujui untuk merahasiakan semua informasi dan data
      pribadi Anda dan Dompet Kilat tidak akan menggunakan data pribadi Anda
      untuk tujuan lain diluar dari penyediaan Layanan Dompet Kilat, kecuali
      sehubungan dengan:
    </p>

    <p class="points">
      <img class="Ellipse" />pencegahan tindakan penipuan dan/atau hal-hal
      sehubungan dengan anti pencucian uang dan tindak pidana terorisme.
    </p>
    <p class="points">
      <img class="Ellipse" />data pribadi yang secara umum diketahui publik dan
      waktu itu belum diketahui melalui setiap pelanggaran hukum yang berlaku;
    </p>
    <p class="points">
      <img class="Ellipse" /> data pribadi tersebut diperoleh secara sah oleh
      Dompet Kilat tanpa melanggar kerahasiaan dari sumber-sumber lain;
    </p>
    <p class="points">
      <img class="Ellipse" />data pribadi tersebut diwajibkan untuk diungkapkan
      oleh hukum, pemerintah, atau lembaga berwenang di bawah aturan yang ada;
    </p>
    <p class="points">
      <img class="Ellipse" />data pribadi tersebut diungkapkan dalam proses
      litigasi apa pun; atau
    </p>
    <p class="points">
      <img class="Ellipse" />orang yang bertindak sebagai pengacara, rekan kerja
      atau apa pihak ketiga yang kami beri wewenang sesuai dengan ketentuan
      hukum.
    </p>
    <p class="Desc">
      Dengan mengakses Platform Dompet Kilat dan/atau menggunakan Layanan Dompet
      Kilat, Anda memahami bahwa segala bentuk komunikasi Dompet Kilat kepada
      Anda sehubungan dengan Layanan Dompet Kilat akan diberikan secara
      elektronik baik melalui email, telepon, atau dipublikasikan melalui
      Platform Dompet Kilat.
    </p>
    <p class="Desc">
      Anda sepakat untuk menerima seluruh dokumen, pemberitahuan dan perjanjian
      secara elektronik yang timbul atas penggunaan Layanan Dompet Kilat. Segala
      persetujuan dari Anda terhadap setiap dokumen, pemberitahuan dan
      perjanjian secara elektronik diberikan dengan melakukan tanda tangan
      secara elektronik dan sepenuhnya tanggung jawab dan mengikat Anda selaku
      pengguna Layanan Dompet Kilat, baik hak maupun kewajiban yang timbul atas
      persetujuan tersebut.
    </p>
    <p class="title-1">VI. HAL – HAL TERKAIT KEKAYAAN INTELEKTUAL</p>
    <p class="Desc">
      Hak kekayaan intelektual Platform ini, termasuk, namun tidak terbatas,
      pada hak cipta, hak paten, termasuk merek dagang untuk dan atas nama
      Dompet Kilat dimiliki secara penuh oleh dan menjadi aset tetap dari Dompet
      Kilat.
    </p>
    <p class="Desc">
      Anda diperbolehkan untuk melihat dan menyalin-cetak diatas kertas isi yang
      disediakan Platform Dompet Kilat, namun:
    </p>
    <p class="points">
      <img class="Ellipse" />seluruh salinan tersebut merupakan hak kekayaan
      intelektual dari Dompet Kilat dan pihak ketiga yang kami berikan lisensi;
      dan
    </p>
    <p class="points">
      <img class="Ellipse" />Anda tidak mengubah dengan cara apapun salinan
      kertas dari bahan-bahan yang telah dicetak, termasuk penghapusan segala
      hak cipta atau kepemilikan lainnya yang terkandung di Platform Dompet
      Kilat.
    </p>
    <p class="Desc">
      Anda setuju tidak akan menggunakan bagian manapun dari Platform Dompet
      Kilat ini untuk:
    </p>
    <p class="points">
      <img class="Ellipse" />menyelipkan atau dengan sengaja atau tidak sengaja
      menularkan atau menyebarkan virus, worm, trojan horse, time bomb, trap
      door atau kode komputer, berkas, program atau membuat permintaan berulang
      yang dirancang untuk mengganggu, merusak atau membatasi fungsi dari
      perangkat lunak, atau perangkat keras komputer, atau peralatan
      telekomunikasi, atau untuk mengurangi kualitas, mengganggu tampilan dari,
      atau merusak fungsi Platform Dompet Kilat ini;
    </p>
    <p class="points">
      <img class="Ellipse" />mengunggah, memasang, mengirimkan surel atau
      sebaliknya menerima, atau menempelkan tautan pada konten apapun yang
      memfasilitasi peretasan data;
    </p>
    <p class="points">
      <img class="Ellipse" />meretas apapun yang menjadi bagian dari Platform
      Dompet Kilat ini;
    </p>
    <p class="points">
      <img class="Ellipse" />mengunggah, mengirimkan surel, atau mengirimkan
      tautan kepada konten mana saja yang melanggar hak kekayaan intelektual
      dari pihak ketiga;
    </p>
    <p class="points">
      <img class="Ellipse" /> mengelakkan atau mencoba mengelakkan, cara
      pengamanan apapun dari Platform Dompet Kilat;
    </p>
    <p class="points">
      <img class="Ellipse" />mengizinkan pihak ketiga mana pun untuk melakukan
      semua hal di atas;
    </p>
    <p class="title-1">VII. KEBIJAKAN PRIVASI DAN KEBIJAKAN COOKIES</p>

    <p class="Desc">
      Ketentuan lebih lanjut sehubungan dengan kebijakan privasi dapat diakses
      pada halaman Kebijakan Privasi.
    </p>
    <p class="Desc">
      Situs ini menggunakan Cookie, yang harus Anda setujui penggunaannya untuk
      menikmati fungsionalitas penuh dari Situs ini. Cookie yang kami gunakan
      akan merekam bagian mana dari Situs ini yang Anda kunjungi dan berapa
      lama. Anda berhak untuk menolak penggunaan Cookie dengan cara
      mengkonfigurasi web jelajah Anda. Mohon untuk diingat, bahwa konfigurasi
      tersebut bisa saja mengganggu beberapa fungsi dari Situs ini. Untuk
      informasi lebih lanjut terkait penggunaan Cookie ini dapat diakses pada
      halaman Kebijakan Privasi.
    </p>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.tanggal {
  height: 20px;
  flex-grow: 0;
  margin: 0 0 16px;
  font-family: Sora;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.8px;
  text-align: left;
  color: #767676;
}
.title-1 {
  /* width: 328px; */
  height: 20px;
  flex-grow: 0;
  margin: 16px 0 12px;
  font-family: Sora;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.8px;
  text-align: left;
  color: #252525;
}
.Desc {
  flex-grow: 0;
  margin: 12px 0;
  font-family: Inter;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: justify;
  color: #252525;
}
.Ellipse {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  margin: 4px 8px 4px 0;
  background-color: #252525;
}
.points {
  /* height: 20px; */
  flex-grow: 0;
  margin: 0 0 5px 20px;
  font-family: Sora;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
</style>
